import styled, { css } from 'styled-components';

import { Badge } from 'components/badge';
import { ButtonWithRef } from 'components/button';

export const AddRowButton = styled(ButtonWithRef)`
  margin-top: 16px;
`;

export const Title = styled.p`
  color: ${({ theme }) => theme.colors.grey.primary.action};
`;

export const StyledBadge = styled(Badge)`
  text-align: unset;
  justify-content: space-between;
`;

export const Divider = styled.p`
  height: 1px;
  width: 100%;
  margin: 16px 0;
  background-color: ${({ theme }) => theme.config.common.border};
`;

export const Value = styled.p<{ isDeduction?: boolean }>`
  ${({ theme, isDeduction }) =>
    isDeduction &&
    css`
      color: ${theme.config.text.red};
    `}
`;

export const ItemDescription = styled.p`
  padding-left: 8px;
  color: ${({ theme }) => theme.colors.grey.primary.action};
`;
